import {defineStore} from 'pinia'
import Roles from "~/utils/roles"
import type {OutputSessionData} from "~/models";

export const useTeamSessionStore = defineStore('teamSession', {
    state: () => ({
        session: <OutputSessionData | null>null
    }),
    actions: {
        async load() {
            const {user} = useAuth()
            if (user.value?.role !== Roles.TEAM.value) {
                return
            }

            this.session = await useApi().getFlySession() || null
        },
    },
})